import { ApiClientService, EntityApiService } from '@dfl/react-security';
import { IBanner } from '../interfaces/IBanner';

class BannerService extends EntityApiService<IBanner> {
  updateStatus = (bannerId: string, status: boolean): any => {
    return ApiClientService.patch(this.getPath(`/${bannerId}`), {
      enabled: status,
    });
  };

  addRegion = (collectionId: string, params: any): any => {
    return ApiClientService.post(`/ms-cms/api/admin/collections/banners/${collectionId}/regions`, params);
  };

  getRegion = (params?: any): any => {
    return ApiClientService.get('/ms-cms/api/admin/collections/banners/config/regions', params);
  };

  /* search = (params?: any, config?: RequestConfig): any => {
    const size = params?.size === 10 ? 16 : params?.size;
    return this.handleSearchResponse(ApiClientService.post(this.getPath('/search'), { ...params, size }, config), size);
  }; */
}

export default new BannerService('/ms-cms/api/banners');
